import React from "react";
import styles from "./css/About.module.css";

const History = () => {
  return (
    <div>
      <h3>My History</h3>
      <p>
        I began my journey in the world of adulthood with a diploma in Business
        Administration - specialized in Accounting. I enjoyed it for a time, but
        eventually I moved to another city, and without a job in the field my
        interest waned. I never quite went back to Accounting.
      </p>
      <p>
        I started working at Dollarama in 2015, and quickly worked my way up to
        a leadership position. I stayed there for many years, learning social
        and management skills along the way.{" "}
      </p>
      <p>
        Finally, in 2021, I decided it was time to change things up and start
        doing something I was passionate about (and also something that would
        earn me enough money to buy more than just food). I spent a long time
        thinking about what I wanted, and eventually settled on Software
        Development. I've always been good with computers - might as well make a
        career out of it.
      </p>
    </div>
  );
};

export default History;
